var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
import { ContextGLDrawMode } from '../base/ContextGLDrawMode';
import { ContextGLBlendEquation, ContextGLBlendFactor } from '../base/ContextGLBlendFactor';
import { ContextGLCompareMode } from '../base/ContextGLCompareMode';
import { ContextGLMipFilter } from '../base/ContextGLMipFilter';
import { ContextGLStencilAction } from '../base/ContextGLStencilAction';
import { ContextGLTextureFilter } from '../base/ContextGLTextureFilter';
import { ContextGLVertexBufferFormat } from '../base/ContextGLVertexBufferFormat';
import { ContextGLWrapMode } from '../base/ContextGLWrapMode';
/**
 * AWAYJS to WebGL constants mapping
 * @see https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/Constants
 */
export var TEXTURE = {
    'texture2d': 0x0DE1,
    'textureCube': 0x8513 // gl.TEXTURE_CUBE_MAP
};
export var WRAP = (_a = {},
    _a[ContextGLWrapMode.REPEAT] = 0x2901,
    _a[ContextGLWrapMode.CLAMP] = 0x812F // gl.CLAMP_TO_EDGE
,
    _a);
export var FILTER = (_b = {},
    _b[ContextGLTextureFilter.LINEAR] = 0x2601,
    _b[ContextGLTextureFilter.NEAREST] = 0x2600,
    _b);
export var MIP_FILTER = (_c = {},
    _c[ContextGLTextureFilter.LINEAR] = (_d = {},
        _d[ContextGLMipFilter.MIPNEAREST] = 0x2701,
        _d[ContextGLMipFilter.MIPLINEAR] = 0x2703,
        _d[ContextGLMipFilter.MIPNONE] = 0x2601 // gl.LINEAR
    ,
        _d),
    _c[ContextGLTextureFilter.NEAREST] = (_e = {},
        _e[ContextGLMipFilter.MIPNEAREST] = 0x2700,
        _e[ContextGLMipFilter.MIPLINEAR] = 0x2702,
        _e[ContextGLMipFilter.MIPNONE] = 0x2600 // gl.NEAREST
    ,
        _e),
    _c);
/* eslint-disable */
//setup shortcut dictionaries
var BF = ContextGLBlendFactor;
var BE = ContextGLBlendEquation;
export var BLEND_OP = (_f = {},
    _f[BF.ONE] = 0x1,
    _f[BF.DESTINATION_ALPHA] = 0x0304,
    _f[BF.DESTINATION_COLOR] = 0x0306,
    _f[BF.ONE_MINUS_DESTINATION_ALPHA] = 0x0305,
    _f[BF.ONE_MINUS_DESTINATION_COLOR] = 0x0307,
    _f[BF.ONE_MINUS_SOURCE_ALPHA] = 0x0303,
    _f[BF.ONE_MINUS_SOURCE_COLOR] = 0x0301,
    _f[BF.SOURCE_ALPHA] = 0x0302,
    _f[BF.SOURCE_COLOR] = 0x0300,
    _f[BF.ZERO] = 0x0 // gl.ZERO
,
    _f);
export var BLEND_EQ = (_g = {},
    _g[BE.ADD] = 0x8006,
    _g[BE.SUBTRACT] = 0x800A,
    _g[BE.REVERSE_SUBTRACT] = 0x800B,
    _g[BE.MIN] = 0x8007,
    _g[BE.MAX] = 0x8008,
    _g);
export var DRAW_MODE = (_h = {},
    _h[ContextGLDrawMode.LINES] = 0x0001,
    _h[ContextGLDrawMode.TRIANGLES] = 0x0004,
    _h);
var CM = ContextGLCompareMode;
export var COMPARE_OP = (_j = {},
    _j[CM.ALWAYS] = 0x0207,
    _j[CM.EQUAL] = 0x0202,
    _j[CM.GREATER] = 0x0204,
    _j[CM.GREATER_EQUAL] = 0x0206,
    _j[CM.LESS] = 0x0201,
    _j[CM.LESS_EQUAL] = 0x0203,
    _j[CM.NEVER] = 0x0200,
    _j[CM.NOT_EQUAL] = 0x0205,
    _j);
var SA = ContextGLStencilAction;
export var STENCIL_ACTION = (_k = {},
    _k[SA.KEEP] = 0x1E00,
    _k[SA.SET] = 0x1E01,
    _k[SA.INCREMENT_SATURATE] = 0x1E02,
    _k[SA.DECREMENT_SATURATE] = 0x1E03,
    _k[SA.INVERT] = 0x150A,
    _k[SA.INCREMENT_WRAP] = 0x8507,
    _k[SA.DECREMENT_WRAP] = 0x8508,
    _k[SA.ZERO] = 0,
    _k);
var VPropConstructor = /** @class */ (function () {
    function VPropConstructor(size, type, normalized) {
        this.size = size;
        this.type = type;
        this.normalized = normalized;
    }
    return VPropConstructor;
}());
var VBF = ContextGLVertexBufferFormat;
export var VERTEX_BUF_PROPS = (_l = {},
    _l[VBF.FLOAT_1] = new VPropConstructor(1, 5126 /* FLOAT */, false),
    _l[VBF.FLOAT_2] = new VPropConstructor(2, 5126 /* FLOAT */, false),
    _l[VBF.FLOAT_3] = new VPropConstructor(3, 5126 /* FLOAT */, false),
    _l[VBF.FLOAT_4] = new VPropConstructor(4, 5126 /* FLOAT */, false),
    _l[VBF.BYTE_1] = new VPropConstructor(1, 5120 /* BYTE */, true),
    _l[VBF.BYTE_2] = new VPropConstructor(2, 5120 /* BYTE */, true),
    _l[VBF.BYTE_3] = new VPropConstructor(3, 5120 /* BYTE */, true),
    _l[VBF.BYTE_4] = new VPropConstructor(4, 5120 /* BYTE */, true),
    _l[VBF.UNSIGNED_BYTE_1] = new VPropConstructor(1, 5121 /* UNSIGNED_BYTE */, true),
    _l[VBF.UNSIGNED_BYTE_2] = new VPropConstructor(2, 5121 /* UNSIGNED_BYTE */, true),
    _l[VBF.UNSIGNED_BYTE_3] = new VPropConstructor(3, 5121 /* UNSIGNED_BYTE */, true),
    _l[VBF.UNSIGNED_BYTE_4] = new VPropConstructor(4, 5121 /* UNSIGNED_BYTE */, true),
    _l[VBF.SHORT_1] = new VPropConstructor(1, 5122 /* SHORT */, false),
    _l[VBF.SHORT_2] = new VPropConstructor(2, 5122 /* SHORT */, false),
    _l[VBF.SHORT_3] = new VPropConstructor(3, 5122 /* SHORT */, false),
    _l[VBF.SHORT_4] = new VPropConstructor(4, 5122 /* SHORT */, false),
    _l[VBF.UNSIGNED_SHORT_1] = new VPropConstructor(1, 5123 /* UNSIGNED_SHORT */, false),
    _l[VBF.UNSIGNED_SHORT_2] = new VPropConstructor(2, 5123 /* UNSIGNED_SHORT */, false),
    _l[VBF.UNSIGNED_SHORT_3] = new VPropConstructor(3, 5123 /* UNSIGNED_SHORT */, false),
    _l[VBF.UNSIGNED_SHORT_4] = new VPropConstructor(4, 5123 /* UNSIGNED_SHORT */, false),
    _l);
